/**
 * Top-level router `errorElement`. Renders a minimal fallback for unexpected
 * render/loader errors so a thrown error doesn't blank the whole app.
 */
import { useEffect, useRef } from 'react';
import { Link } from '@mui/material';
import { isRouteErrorResponse, Link as RouterLink, useRouteError } from 'react-router-dom';

export function RouteError() {
  const error = useRouteError();
  const headingRef = useRef<HTMLHeadingElement>(null);
  let message = 'Something went wrong.';
  if (isRouteErrorResponse(error)) {
    message = `${error.status} ${error.statusText}`;
  }
  useEffect(() => {
    headingRef.current?.focus({ preventScroll: true });
  }, []);
  return (
    <main role="alert" style={{ padding: '2rem', maxWidth: '32rem', margin: '0 auto' }}>
      <h1 ref={headingRef} tabIndex={-1}>
        Unexpected error
      </h1>
      <p>{message}</p>
      <Link component={RouterLink} to="/members">
        Return to Members
      </Link>
    </main>
  );
}
